import { Fonts } from '@videoblocks/jelly-renderer';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';

import { selectIsLoading } from '../selectors/user';
import { standardizeFont } from '../utils/fonts';
import useUploads from './useUploads';

export default function useFonts({ organizationId }) {
  const userIsLoading = useSelector(selectIsLoading);

  const {
    data: userFontsData,
    isLoadingMore: isLoadingUserFonts,
    deleteUpload: deleteUserFont,
    refetch: refetchUserFonts,
  } = useUploads('font');

  const {
    data: orgFontsData,
    isLoadingMore: isLoadingOrgFonts,
    associateUpload,
    disassociateUpload,
    refetch: refetchOrgFonts,
  } = useUploads('font', {
    organization: organizationId,
    skip: userIsLoading,
  });

  const userFonts = userFontsData.map(standardizeFont).filter((font) => !!font);
  const hasUserFonts = !isLoadingUserFonts && !isEmpty(userFonts);

  const orgFonts = orgFontsData.map(standardizeFont).filter((font) => !!font);
  const hasOrgFonts = !isLoadingOrgFonts && !isEmpty(orgFonts);

  const allFonts = Fonts.GOOGLE_FONTS.concat(userFonts, orgFonts);
  const isLoadingMoreAllFonts = isLoadingUserFonts || isLoadingOrgFonts;

  return {
    userFonts,
    hasUserFonts,
    deleteUserFont,
    refetchUserFonts,
    orgFonts,
    hasOrgFonts,
    associateUpload,
    disassociateUpload,
    refetchOrgFonts,
    allFonts,
    isLoadingMoreAllFonts,
  };
}
